export class AgentChatError extends Error {
  override readonly name = 'AgentChatError';

  constructor(
    message: string,
    readonly statusCode: number,
  ) {
    super(message);
  }
}
